import { ApolloCache } from "@apollo/client"

import { evict } from "shared/api/evict"

export function evictProjectHistory(id: string, cache: ApolloCache<object>) {
  evict({
    cache,
    id,
    typename: "ProjectHistoryEntity"
  })
}
